<template>
    <v-layout column>
      <v-layout row>
        <v-flex xs12>
          <about-tile :can-view-about="true" :can-view-chair="true" :can-view-sponsors="true"></about-tile>
        </v-flex>
      </v-layout>
    </v-layout>
  </template>
  

<script>
    import { routerNames, userRoles } from '../appCommon.constants';
    import { communityCommonConstant, networkConstants } from '../ChapterPage/communityCommon.constant';
    import { trackEventConstant } from "@/plugins/analytics.constant";
    import communityLeftSideBarMixin from "../../mixins/communityLeftSideBarMixin";
    import AboutTile from '../ChapterPage/AboutTile/AboutTile';


    export default {
        name: 'CommunitiesLeftSidebar',
        mixins: [communityLeftSideBarMixin],
        created() {},
        components: {
            trackEventConstant,
            AboutTile,
        },
        data: () => {
            return {
                networkType: null,
                isNetworkAdmin: false,
                communityCommonConstant,
                networkConstants,
                routerNames,
            };
        },
        methods: {
            isCommunitiesPage() {
                return this.$route.name === this.routerNames.COMMUNITIES && true;
            },
        },
        computed: {
            isVisible() {
                return this.$route.name === this.routerNames.COMMUNITIES;
            },
        },
    };
</script>
